import { useTranslation } from "react-i18next";

const BASE_BADGE_STYLE = {
  display: "inline-flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "center",
  gap: 4,
  color: "#FFFFFF",
  fontWeight: "bold",
  borderRadius: 5,
  padding: "3px 6px",
  textAlign: "center",
  borderWidth: 0,
  fontSize: 12,
  lineHeight: 1,
  whiteSpace: "nowrap",
  verticalAlign: "middle",
};

const STATUS_META = {
  inside: { className: "inside", backgroundColor: "#5cb85c", translationKey: "inside" },
  outside: { className: "outside", backgroundColor: "#d9534f", translationKey: "outside" },
  unknown: { className: "unknown", backgroundColor: "#f0ad4e", translationKey: "unknown" },
};

const formatTimestamp = (timestampSeconds) => {
  if (!timestampSeconds) {
    return null;
  }

  return new Intl.DateTimeFormat(undefined, {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  }).format(new Date(timestampSeconds * 1000));
};

export const PositionStatus = ({ status = "unknown", timestamp }) => {
  const { t } = useTranslation();
  const meta = STATUS_META[status] || STATUS_META.unknown;
  const formattedTimestamp = status === "unknown" ? null : formatTimestamp(timestamp);
  const uniformWidthCh = Math.max(t("inside").length, t("outside").length, t("unknown").length, formattedTimestamp?.length || 0) + 1;

  return (
    <span
      className={meta.className}
      style={{
        ...BASE_BADGE_STYLE,
        backgroundColor: meta.backgroundColor,
        minWidth: `${uniformWidthCh}ch`,
        boxSizing: "border-box",
      }}
    >
      <span>{t(meta.translationKey)}</span>
      {formattedTimestamp && <span>{formattedTimestamp}</span>}
    </span>
  );
};

export const Inside = () => {
  return <PositionStatus status="inside" />;
};

export const Unknown = () => {
  return <PositionStatus status="unknown" />;
};

export const Outside = () => {
  return <PositionStatus status="outside" />;
};
